import { gql } from '@apollo/client';
const GET_UNASSIGNED_PRODUCTS = gql `
  query GetUnassignedProducts(
    $first: Int
    $after: String
    $name: String
    $categoryId: [ID]
    $supplierId: [ID]
    $statusId: String
    $functionIds: [ID]
    $sustainabilityIds: [ID]
    $certificateIds: [ID]
    $continentIds: [ID]
    $countryIds: [ID]
    $eventIds: [ID]
    $mainCategoryIds: [ID]
  ) {
    autocomplete {
      id
      unassignedProducts(
        first: $first
        after: $after
        categoryId: $categoryId
        name: $name
        supplierId: $supplierId
        status: $statusId
        functionIds: $functionIds
        sustainabilityIds: $sustainabilityIds
        certificateIds: $certificateIds
        continentIds: $continentIds
        countryIds: $countryIds
        eventIds: $eventIds
        mainCategoryIds: $mainCategoryIds
      ) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            name
            status
            pictures {
              edges {
                node {
                  id
                  image
                }
              }
            }
            supplier {
              id
              code
              shortName
              fullName
            }
            category {
              id
              type
              typeLabelPL
              typeLabelEN
              typeIcon
            }
            producerCode {
              name
            }
            productVariantsCount
            activeProductVariantsCount
          }
        }
      }
    }
  }
`;
export default GET_UNASSIGNED_PRODUCTS;
